import { SET_BRANDS, SET_CATEGORIES, SET_PRODUCTS, SET_SUB_CATEGORIES, SET_SWIPPED } from "../ConstAction";

const initialState = {};
export const CategoriesData = (state = initialState, action) => {

  switch (action.type) {

    case SET_CATEGORIES:
      return {
        ...state,
        list: action.response.data,
      };
    case SET_SUB_CATEGORIES:
      return {
        ...state,
        sublist: action.response.data,
      };
    case SET_BRANDS:
      return {
        ...state,
        brands: action.response,
      };
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.response,
      };
    case SET_SWIPPED:
      return {
        ...state,
        swipped: action.response.data
      }
    default:
      return { ...state };
  }
};
